// 인증 세션 만료 신호 — axiosClient(React 컴포넌트 트리 밖)와 AuthContext/useOfflineSync(안쪽) 사이의
// 다리다(2026-09-22, 사용자 요청). axiosClient의 401 핸들러가 여기로 신호만 올리고 **페이지를 떠나지
// 않는다** — 예전에는 401을 맞으면 곧바로 `window.location.href = '/login'`로 전체 페이지를 이동시켜서,
// 배경에서 돌던 오프라인 큐 재전송(useOfflineSync)이 그 순간 통째로 끊기고 기록입력 중이던 값도 함께
// 사라질 뻔했다. AuthContext가 이 신호를 구독해 `SessionExpiredModal`로 비밀번호만 다시 받고, 재인증에
// 성공하면 토큰만 바꿔 끼워서 화면·오프라인 큐를 그대로 이어간다.
//
// `isSessionExpired()`는 useOfflineSync가 "지금 재전송을 시도해 봐야 어차피 401일 것"을 미리 알고
// 헛수고(+ MAX_ATTEMPTS 소모)를 건너뛰는 데 쓴다.

type Listener = () => void

const listeners = new Set<Listener>()
let expired = false

export function markSessionExpired(): void {
  expired = true
  listeners.forEach((l) => l())
}

/** 재인증(재로그인/조용한 재발급) 성공 시 호출 — 신호를 내리기만 하고 리스너는 부르지 않는다
 *  (성공은 각자 자기 state를 직접 갱신하므로 별도 통지가 필요 없다). */
export function clearSessionExpired(): void {
  expired = false
}

export function isSessionExpired(): boolean {
  return expired
}

/** 구독 — 컴포넌트의 useEffect에서 걸고 cleanup에서 반환값을 호출해 해지한다. */
export function onSessionExpired(listener: Listener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
